import React, { useEffect, useState } from "react";
import axios from "axios";

function ModalAuditoriaAditivo({ projetoId, onClose }) {
  const [aditivos, setAditivos] = useState([]);
  const [decisoes, setDecisoes] = useState({});
  const [mensagem, setMensagem] = useState("");

  useEffect(() => {
    const fetchAditivos = async () => {
      try {
        const token = localStorage.getItem("Token");
        const res = await axios.get("/api/aditivos", {
          headers: { Authorization: `Bearer ${token}` },
        });
        const pendentes = res.data.filter(
          (a) => a.status === "pendente" && a.id_projeto === projetoId
        );
        setAditivos(pendentes);
      } catch (err) {
        console.error("Erro ao buscar aditivos:", err);
        setMensagem("Erro ao carregar aditivos pendentes.");
      }
    };

    fetchAditivos();
  }, [projetoId]);

  const handleAcao = async (id, acao) => {
    const token = localStorage.getItem("Token");
    const decisao = decisoes[id];
    if (!decisao || !decisao.status) {
      alert("Selecione aprovado ou reprovado.");
      return;
    }
    if (decisao.status === "rejeitar" && !decisao.justificativa?.trim()) {
      alert("Justificativa é obrigatória para reprovação.");
      return;
    }

    try {
      await axios.put(
        `/api/aditivos/${id}/${acao}`,
        { descricao_decisao: decisao.justificativa || "" },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setMensagem(
        `Aditivo ${
          decisao.status === "aprovar" ? "aprovado" : "rejeitado"
        } com sucesso.`
      );
      setAditivos((prev) =>
        prev.map((a) =>
          a.id === id
            ? {
                ...a,
                status: decisao.status === "aprovar" ? "aprovado" : "rejeitado",
              }
            : a
        )
      );
    } catch (err) {
      console.error(err);
      setMensagem("Erro ao processar aditivo.");
    }
  };

  return (
    <div
      className="modal d-block"
      tabIndex="-1"
      style={{ background: "#00000099" }}
    >
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Auditoria de Aditivos</h5>
            <button className="btn-close" onClick={onClose}></button>
          </div>

          <div className="modal-body">
            {mensagem && <div className="alert alert-info">{mensagem}</div>}

            {aditivos.length === 0 ? (
              <p>Nenhuma solicitação pendente.</p>
            ) : (
              aditivos.map((ad) => (
                <div key={ad.id} className="border rounded p-3 mb-3">
                  <div className="row">
                    <div className="col-md-7">
                      <p>
                        <strong>Tipo:</strong>{" "}
                        {ad.tipo === "valor"
                          ? "Aditivo de Valor"
                          : "Aditivo de Prazo"}
                      </p>
                      {ad.tipo === "valor" && (
                        <p>
                          <strong>Valor:</strong> R${" "}
                          {parseFloat(ad.valor).toLocaleString("pt-BR", {
                            minimumFractionDigits: 2,
                          })}
                        </p>
                      )}
                      {ad.tipo === "prazo" && (
                        <p>
                          <strong>Prazo:</strong> {ad.prazo} dias
                          <strong>Etapa:</strong> ETAPA {ad.etapa}
                        </p>
                      )}
                      <p>
                        <strong>Secretaria:</strong>{" "}
                        {ad.secretaria_nome || ad.id_secretaria}
                      </p>
                      <p>
                        <strong>Justificativa:</strong> {ad.descricao_pedido}
                      </p>
                      <p>
                        <strong>Criado em:</strong> {ad.data_criacao}
                      </p>
                      <p>
                        <strong>Solicitante:</strong> {ad.criado_por_nome}
                      </p>
                      <p>
                        <strong>Status:</strong> {ad.status}
                      </p>
                    </div>
                    <div className="col-md-5">
                      <div className="mb-2">
                        <label className="form-label fw-semibold">Status</label>
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name={`status_${ad.id}`}
                            id={`aprovado_${ad.id}`}
                            checked={decisoes[ad.id]?.status === "aprovar"}
                            onChange={() =>
                              setDecisoes((prev) => ({
                                ...prev,
                                [ad.id]: { ...prev[ad.id], status: "aprovar" },
                              }))
                            }
                          />
                          <label
                            className="form-check-label"
                            htmlFor={`aprovado_${ad.id}`}
                          >
                            Aprovado
                          </label>
                        </div>
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name={`status_${ad.id}`}
                            id={`rejeitar_${ad.id}`}
                            checked={decisoes[ad.id]?.status === "rejeitar"}
                            onChange={() =>
                              setDecisoes((prev) => ({
                                ...prev,
                                [ad.id]: { ...prev[ad.id], status: "rejeitar" },
                              }))
                            }
                          />
                          <label
                            className="form-check-label"
                            htmlFor={`rejeitar_${ad.id}`}
                          >
                            Reprovado
                          </label>
                        </div>
                      </div>
                      <div className="mb-2">
                        <label className="form-label fw-semibold">
                          Justificativa
                        </label>
                        <textarea
                          className="form-control"
                          rows={2}
                          value={decisoes[ad.id]?.justificativa || ""}
                          onChange={(e) =>
                            setDecisoes((prev) => ({
                              ...prev,
                              [ad.id]: {
                                ...prev[ad.id],
                                justificativa: e.target.value,
                              },
                            }))
                          }
                        ></textarea>
                      </div>
                      <div className="d-flex gap-2">
                        <button
                          className="btn btn-success"
                          onClick={() => handleAcao(ad.id, "aprovar")}
                          disabled={decisoes[ad.id]?.status !== "aprovar"}
                        >
                          Enviar Decisão
                        </button>
                        <button
                          className="btn btn-danger"
                          onClick={() => handleAcao(ad.id, "rejeitar")}
                          disabled={
                            decisoes[ad.id]?.status !== "rejeitar" ||
                            !decisoes[ad.id]?.justificativa
                          }
                        >
                          Enviar Decisão
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>

          <div className="modal-footer">
            <button className="btn btn-secondary" onClick={onClose}>
              Fechar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ModalAuditoriaAditivo;
